module.exports = __webpack_public_path__ + "static/functions-screen-5-0971d76d2cbb5d17355df3363b58a926.png";